import React, {forwardRef} from 'react'
import RSelect, {components} from 'react-select'
import {ReactComponent as CaretIcon} from '../assets/icons/keyboard_arrow_down.svg'
import classnames from 'classnames'

export const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
        <CaretIcon />
    </components.DropdownIndicator>
)

export const DropdownMenuStyled = (props) => {
    return (
        <components.Menu {...props} className={classnames('Menu', props.className)} unstyled>
            {props.children}
        </components.Menu>
    )
}

const Placeholder = ({className, ...rest}) => {
    return <components.Placeholder className={classnames('Placeholder', className)} {...rest} />
}

const Option = (props) => {
    const {data} = props
    return (
        <components.Option {...props} className={classnames('Option', props.className)}>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                {data.color && (
                    <div
                        style={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            backgroundColor: data.color,
                            border: '1px solid rgba(9, 9, 9, 0.1)',
                            flexShrink: 0,
                        }}
                    />
                )}
                {data.icon && (
                    <div style={{width: '20px', height: '20px', display: 'flex', alignItems: 'center'}}>
                        {data.icon}
                    </div>
                )}
                <span>{data.label}</span>
            </div>
        </components.Option>
    )
}

const SingleValue = (props) => {
    const {data} = props
    return (
        <components.SingleValue {...props} className={classnames('SingleValue', props.className)}>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                {data.color && (
                    <div
                        style={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            backgroundColor: data.color,
                            border: '1px solid rgba(9, 9, 9, 0.1)',
                            flexShrink: 0,
                        }}
                    />
                )}
                {data.icon && (
                    <div style={{width: '20px', height: '20px', display: 'flex', alignItems: 'center'}}>
                        {data.icon}
                    </div>
                )}
                <span>{data.label}</span>
            </div>
        </components.SingleValue>
    )
}

const Select = forwardRef(({components, className, ref, ...rest}) => {
    return (
        <RSelect
            ref={ref}
            className={classnames('Dropdown', className)}
            components={{
                DropdownIndicator,
                IndicatorSeparator: () => null,
                Menu: DropdownMenuStyled,
                Placeholder,
                Option,
                SingleValue,
                ...components,
            }}
            menuPlacement={'auto'}
            {...rest}
        />
    )
})

export default Select
